import React from 'react';
import { Layout, Icon } from 'antd';
import { HashRouter as Router, Route } from "react-router-dom";
import Menuitems from './Menuitems';
import NewPage from './NewPage';
import './Menu.css';

const { Header, Content, Sider } = Layout;

//取根節點陣列
function getRoot(MenuData) {
  let arr = [];
  // eslint-disable-next-line
  MenuData.map((menu) => {
    if (menu.root === true) arr.push(menu.id);
  })
  return arr;
}

//取子節點陣列
function collectChilds(arr) {
  return arr.map((node) => {
    if (node.children) {
      return collectChilds(node.children);
    }
    return node;
  })
}

//將巢狀json攤平為一維陣列
function flattenArr(arr) {
  return arr.reduce((pre, cur) => pre.concat(Array.isArray(cur) ? flattenArr(cur) : cur), [])
}

class MainLayout extends React.Component {

  state = {
    //antd變數
    collapsed: false,
    rootSubmenuKeys: [],
    //自宣告變數
    Menudata: [],
    childs: [],
    text: "",
    logoPath: "",
  };

  //側邊欄位RWD 寬度768px為切換分界點
  updateDimensions = () => {
    if (window.innerWidth < 768) {
      this.setState({
        collapsed: true
      });
    }
    else {
      this.setState({
        collapsed: false
      });
    }
  }

  //動態依據json產生route
  renderRouter = (Menudata) => {
    //transform N-dimension array to 1d array
    let flatChilds = flattenArr(collectChilds(Menudata))
    return (flatChilds.map((menu, index) => {
      return (<Route path={menu.path} render={() => (<NewPage />)} />);
    }));
  }

  //處理側邊MENU收合觸發
  onClick = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  }

  componentDidMount() {
    let _this = this;
    //取得json，放到state中
    fetch('./Menudata.json')
      .then((response) => response.json())
      .then(function (Menudata) {
        _this.setState({ Menudata: Menudata['data'], text: Menudata['text'] ,logoPath: Menudata['logoPath']});
        return Menudata['data'];
      })
      .then(function (data) {
        //處理根目錄自動導向到第一個子節點
        let firstChild = flattenArr(collectChilds(data))[0]["path"];
        _this.setState({ rootSubmenuKeys: getRoot(data) });
        window.onhashchange = function () {
          if (window.location.hash === "#/") {
            window.location.hash = firstChild;
          }
        }
        if (window.location.hash === "#/") {
          window.location.hash = firstChild;
        }
      });
    //RWD收合側邊導覽列
    window.addEventListener("resize", this.updateDimensions);
    this.updateDimensions();
  }

  //註銷事件
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  render() {
    return (
      <Router>
        <Layout style={{ height: '100vh' }}>
          <Sider
            collapsedWidth="0"
            width={280}
            trigger={null}
            collapsible
            collapsed={this.state.collapsed}
            style={{ overflow: 'auto' }}
          >
            {/* 這邊把參數傳到Menudata.js */}
            <Menuitems 
              Menu_data={this.state.Menudata} 
              root_SubmenuKeys={this.state.rootSubmenuKeys} 
              text={this.state.text}
              logoPath={this.state.logoPath}
            />
          </Sider>
          <Layout>
            <Header>
              <Icon
                className="trigger"
                type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'}
                onClick={this.onClick}
              />
            </Header>
            {/* 右側區域 */}
            <Content style={{ margin: '24px 16px 0' }}>
              <div style={{ padding: 14, background: '#f0f2f5', marginLeft: 'auto', marginRight: 'auto' }}>
                <div style={{ height: '90vh' }}>
                  {this.renderRouter(this.state.Menudata)}
                </div>
              </div>
            </Content>
          </Layout>
        </Layout>
      </Router>);
  }
}

export default MainLayout;



// WEBPACK FOOTER //
// ./src/components/MainLayout.js